import ItemViewState from '../../store/schema/ItemViewState';
import { mutatorAction } from 'satcheljs';

export const incrementLikeButtonCount = mutatorAction(
    'incrementLikeButtonCount',
    (viewState: ItemViewState) => {
        if (viewState.likeUnlikeTracker) {
            viewState.likeUnlikeTracker.likeButtonClickCount++;
        }
    }
);
